
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/avs",
      function () {
        return require("private-next-pages/avs.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/avs"])
      });
    }
  